import * as constants from './constants';
import * as apiHelper from '../../apiHelper';
import calendarHandler from 'node-ical';

const controller = "listing";

export function setFeaturedListings(listings) {
  return {
    type: constants.SET_FEATURED_LISTINGS,
    data: listings
  }
}

export function setExtendedStayListings(listings) {
  return {
    type: constants.SET_EXTENDED_STAY_LISTINGS,
    data: listings
  }
}

export function setListingList(listings) {
  return {
    type: constants.SET_LISTING_LIST,
    data: listings
  }
}

export function setSelectedListing(listing) {
  return {
    type: constants.SET_SELECTED_LISTING,
    data: listing
  }
}

export function setSelectedListingBookings(bookings) {
  return {
    type: constants.SET_SELECTED_LISTING_BOOKINGS,
    data: bookings
  }
}

export function setSelectedListingCalendars(calendars) {
  return {
    type: constants.SET_SELECTED_LISTING_CALENDARS,
    data: calendars
  }
}

export function getFeaturedListings(data) {
  return (dispatch) => {
    return apiHelper.apiPost('featuredlistings', data, null, null)
      .then(response => response.json())
      .then(json => dispatch(setFeaturedListings(json)));
  }
}

export function getFeaturedListingsUsingID(ids) {
  return (dispatch) => {
    return apiHelper.apiPost('fetch-wp/listings', {
      listing: ids
    }, null, null)
      .then(response => response.json())
      .then(json => dispatch(setFeaturedListings(json)));
  }
}

export function getExtendedStayListings() {
  return (dispatch) => {
    return apiHelper.apiGet(controller, null, null, ['extendedStay'])
      .then(response => response.json())
      .then(json => dispatch(setExtendedStayListings(json.listingData)));
  }
}

export function getListings() {
  return (dispatch) => {
    return apiHelper.apiGet(controller, null, null)
      .then(response => response.json())
      .then(json => dispatch(setListingList(json.listings)))
  }
}

export function getSelectedListingById(id) {
  return (dispatch) => {
    return apiHelper.apiGet(controller, null, id)
      .then(response => response.json()).then(json => {
        dispatch(setSelectedListing(json.listing));
        dispatch(getCalendars(json.listing.calendars));
      });
  }
}

export function getBookings(id) {
  return (dispatch) => {
    return apiHelper.apiGet('bookings', null, id, 'listing')
      .then(response => response.json())
      .then(json => dispatch(setSelectedListingBookings(json.bookings.filter(b =>
        b.bookingPaymentStatus !== 'Cancelled'
        && b.bookingPaymentStatus !== 'Pending'
        && b.bookingRequestStatus === 'Accepted'))))
  }

}

function getCalendars(urls) {
  let calendars = [];
  let promises = [];

  if (!!urls) {
    urls.forEach(url => {
      promises.push(
        apiHelper.apiPost('calendar', { url: url })
          .then(response => response.text())
          .then(txt => calendarHandler.parseICS(txt))
          .then(data => calendars.push(data))
      );
    });
  }

  return (dispatch) => {
    Promise.all(promises).then(() =>
      dispatch(setSelectedListingCalendars(calendars))
    );
  }
}

export function addNewReview(listingId, review, cb) {
  return (dispatch, getState) => {
    let state = getState();
    let global = state.Global;
    return apiHelper.apiPost(controller, review, global.token, listingId, "reviews")
      .then(response => response.json())
      .then(json => { cb() })
  }
}

export function addResponseToReview(review) {
  return (dispatch, getState) => {
    let state = getState();
    let global = state.Global;
    let listing = state.BrowseListings.selectedListing;
    let review = listing.reviews.filter(r => r._id === reviewId);
    if (review.length === 0)
      return null;
    review = review[0];
    review.response = response;

    return apiHelper.apiPost(controller, review, global.token, listing._id, "reviews")
      .then(response => response.json())
      .then(json => { /* Review Uploaded */ })
  }
}


export function updateListingViews(listingId, incrementBy) {
  return (dispatch, getState) => {
    let state = getState();
    let global = state.Global;
    return apiHelper.apiPut(controller, { increment: incrementBy }, global.token, listingId, 'view')
  }
}

export function sendShareListingEmail(listingId, recipients, message) {
  return (dispatch, getState) => {
    let state = getState();
    let global = state.Global;
    return apiHelper.apiPut(controller, { recipients, message }, global.token, listingId, "share")
  }
}
